module.exports = __webpack_public_path__ + "img/whatsapp.4a316bcf.png";